/**
 * Polskie etykiety domen uprawnień (prefiks kodu PERM przed pierwszą kropką).
 * Tylko warstwa prezentacji - kody PERM w backendzie pozostają angielskie.
 */
const DOMAIN_LABELS_PL: Record<string, string> = {
  access: 'Dostęp i widzialność',
  contracts: 'Umowy',
  partners: 'Kontrahenci',
  platform: 'Konfiguracja systemu',
  audit: 'Audyt',
}

/** Etykieta domeny po polsku; dla nieznanej domeny - kod z wielką literą. */
export function domainLabelPl(domain: string): string {
  return DOMAIN_LABELS_PL[domain] ?? domain.charAt(0).toUpperCase() + domain.slice(1)
}
